<template>
  <div style="width: 100%; margin-top: 1rem">
    <!-- GROUPS -->
    <NsrRbuItemModuleGroup
      v-for="(group, groupIdx) in groups"
      :key="groupIdx"
      :group="group"
      :idx="groupIdx"
      @update="onGroupUpdate(groupIdx, $event)"
      @delete="removeGroup(groupIdx)"
    ></NsrRbuItemModuleGroup>

    <!-- ADD GROUP -->
    <v-card-actions>
      <v-btn color="primary" outlined @click="addGroup">Add Group </v-btn>
    </v-card-actions>

    <!-- SUMMARY -->
    <div class="nsr-item-summary">
      <div class="nsr-item-summary-header">Item Summary</div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="nsr-extra-item-column-1"></th>
              <th class="nsr-extra-item-column-2"></th>
              <th class="nsr-extra-item-column-price">Price</th>
              <th class="nsr-extra-item-column-multiplier">Multiplier</th>
              <th class="nsr-extra-item-column-formula">Formula</th>
              <th class="nsr-extra-item-column-description">Description</th>
              <th class="nsr-extra-item-column-actions"></th>
            </tr>
          </thead>
          <tbody>
            <!-- Group -->
            <tr
              v-for="(group, idx) in groups"
              class="no-border-table"
              :key="idx"
            >
              <NsrItemGroupSummaryRow
                :group="group"
                :idx="idx"
                @update="onSummaryGroupUpdate(idx, $event)"
              ></NsrItemGroupSummaryRow>
            </tr>

            <!-- Group Total -->
            <tr class="bordered-row" v-if="groups.length > 1">
              <td></td>
              <td>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 1rem;
                    padding-top: 1rem;
                    padding-bottom: 1rem;
                  "
                >
                  <span>Total</span>
                  <v-select
                    outlined
                    dense
                    hide-details
                    attach
                    :items="moduleGroupValueModeOptions"
                    :value="rbuItem.module_group_value_mode"
                    @input="onUpdate({ module_group_value_mode: $event })"
                    style="flex: 0 0 150px"
                  ></v-select>
                </div>
              </td>
              <td>{{ $parseCurrency(compAfterSummaryGroupTotalFormula) }}</td>
              <td></td>
              <td>
                <div
                  class="flex"
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    gap: 5px;
                  "
                >
                  <v-textarea
                    outlined
                    auto-grow
                    rows="1"
                    dense
                    hide-details
                    :value="summaryGroupTotalFormulaPrefix"
                    @input="
                      onSummaryGroupTotalFormulaUpdate(
                        $event,
                        summaryGroupTotalFormulaSuffix
                      )
                    "
                  ></v-textarea>

                  <div class="rbu-rate-box">
                    {{
                      rbuItem.module_group_value_mode === "SUM" ? "Sum" : "Avg"
                    }}
                    <br />({{ $parseCurrency(compBeforeAdjustments) }})
                    <!-- <br />({{ $parseCurrency(beforeAdjustmentsNoFormula) }}) -->
                  </div>

                  <v-textarea
                    outlined
                    dense
                    hide-details
                    auto-grow
                    rows="1"
                    :value="summaryGroupTotalFormulaSuffix"
                    @input="
                      onSummaryGroupTotalFormulaUpdate(
                        summaryGroupTotalFormulaPrefix,
                        $event
                      )
                    "
                  ></v-textarea>
                </div>
              </td>
              <td>
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  placeholder="Description"
                  :value="rbuItem.module_group_summary_description"
                  @input="
                    onUpdate({ module_group_summary_description: $event })
                  "
                ></v-textarea>
              </td>
            </tr>

            <!-- Adjustment -->
            <tr
              v-if="rbuItem.adjustment_value_first"
              class="no-border-table bordered-row"
            >
              <td><span style="color: rgba(0, 0, 0, 0.4)">Adjustment</span></td>
              <td>
                <div>
                  <div>
                    <span>Adjustment in $</span>
                    <span></span>
                  </div>
                </div>
              </td>
              <td>{{ $parseCurrency(rbuItem.adjustment_value) }}</td>
              <td></td>
              <td>
                <v-textarea
                  outlined
                  dense
                  hide-details
                  placeholder="Formula"
                  auto-grow
                  rows="1"
                  clearable
                  :value="rbuItem.adjustment_value_formula"
                  @input="onAdjustmentValueFormulaUpdate"
                ></v-textarea>
              </td>
              <td>
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  placeholder="Description"
                  :value="rbuItem.adjustment_value_descriptions"
                  @input="onUpdate({ adjustment_value_descriptions: $event })"
                ></v-textarea>
              </td>
              <td>
                <v-btn
                  icon
                  color="primary"
                  @click="
                    onUpdate({
                      adjustment_value_first: !rbuItem.adjustment_value_first,
                    })
                  "
                >
                  <v-icon>mdi-swap-vertical</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr
              :class="[
                'no-border-table',
                { 'bordered-row': !rbuItem.adjustment_value_first },
              ]"
            >
              <td>
                <span
                  v-if="!rbuItem.adjustment_value_first"
                  style="color: rgba(0, 0, 0, 0.4)"
                  >Adjustment</span
                >
              </td>
              <td>
                <div>
                  <div>
                    <span
                      >Adjustment in %
                      {{
                        rbuItem.adjustment_percentage
                          ? `(${(
                              parseFloat(rbuItem.adjustment_percentage) - 100
                            ).toFixed(2)}%)`
                          : ""
                      }}</span
                    >
                    <span></span>
                  </div>
                </div>
              </td>
              <td></td>
              <td>{{ rbuItem.adjustment_percentage }}%</td>
              <td>
                <v-textarea
                  outlined
                  dense
                  hide-details
                  placeholder="100"
                  auto-grow
                  rows="1"
                  clearable
                  :value="rbuItem.adjustment_percentage_formula"
                  @input="onAdjustmentPercentageFormulaUpdate"
                ></v-textarea>
              </td>
              <td>
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  placeholder="Description"
                  :value="rbuItem.adjustment_percentage_descriptions"
                  @input="
                    onUpdate({ adjustment_percentage_descriptions: $event })
                  "
                ></v-textarea>
              </td>
              <td>
                <v-btn
                  icon
                  color="primary"
                  @click="
                    onUpdate({
                      adjustment_value_first: !rbuItem.adjustment_value_first,
                    })
                  "
                >
                  <v-icon>mdi-swap-vertical</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-if="!rbuItem.adjustment_value_first" class="no-border-table">
              <td></td>
              <td>
                <div>
                  <div>
                    <span>Adjustment in $</span>
                    <span></span>
                  </div>
                </div>
              </td>
              <td>{{ $parseCurrency(rbuItem.adjustment_value) }}</td>
              <td></td>
              <td>
                <v-textarea
                  outlined
                  dense
                  hide-details
                  placeholder="Formula"
                  auto-grow
                  rows="1"
                  clearable
                  :value="rbuItem.adjustment_value_formula"
                  @input="onAdjustmentValueFormulaUpdate"
                ></v-textarea>
              </td>
              <td>
                <v-textarea
                  outlined
                  auto-grow
                  rows="1"
                  dense
                  hide-details
                  placeholder="Description"
                  :value="rbuItem.adjustment_value_descriptions"
                  @input="onUpdate({ adjustment_value_descriptions: $event })"
                ></v-textarea>
              </td>
              <td>
                <v-btn
                  icon
                  color="primary"
                  @click="
                    onUpdate({
                      adjustment_value_first: !rbuItem.adjustment_value_first,
                    })
                  "
                >
                  <v-icon>mdi-swap-vertical</v-icon>
                </v-btn>
              </td>
            </tr>

            <!-- TOTAL -->
            <tr class="bordered-row">
              <td></td>
              <td style="text-align: right">Total</td>
              <td colspan="2">
                <span style="font-weight: bold">{{
                  $parseCurrency(rbuItem.calculated_rate || 0)
                }}</span>
              </td>
              <td colspan="3"></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import {
  onMounted,
  ref,
  watch,
  computed,
  provide,
} from "@vue/composition-api/dist/vue-composition-api";
import { ACTION_TYPES } from "@/store/types";
import NsrRbuItemModuleGroup from "@/components/nsr/NsrRbuItemModuleGroup";
import { RBU_MODULE_GROUP_VALUE_MODE } from "@/constants";
import floatingPointFix from "js-floating-point";
import NsrItemGroupSummaryRow from "./NsrItemGroupSummaryRow.vue";

export default {
  name: "NsrRbuEditor",
  components: { NsrRbuItemModuleGroup, NsrItemGroupSummaryRow },
  props: {
    nsrItem: Object,
    rbuItem: Object,
    // refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    provide("NSR_ITEM", props.nsrItem);
    provide("NSR_RBU_ITEM", props.rbuItem);

    const groups = ref([]);
    const moduleGroupValueModeOptions = computed(() => {
      return [
        { text: "Average", value: RBU_MODULE_GROUP_VALUE_MODE.AVERAGE },
        { text: "Sum", value: RBU_MODULE_GROUP_VALUE_MODE.SUM },
      ];
    });

    const compBeforeAdjustments = computed(() => {
      return beforeAdjustments();
    });

    const summaryGroupTotalFormulaPrefix = computed(() => {
      const components = (
        props.rbuItem.module_group_summary_formula || ""
      ).split("{{value}}");

      if (components.length === 2) {
        return components[0];
      }
      return "";
    });
    const summaryGroupTotalFormulaSuffix = computed(() => {
      const components = (
        props.rbuItem.module_group_summary_formula || ""
      ).split("{{value}}");

      if (components.length === 2) {
        return components[1];
      }
      return "";
    });

    // onSummaryGroupTotalFormulaUpdate
    const onSummaryGroupTotalFormulaUpdate = function (prefix, suffix) {
      onUpdate({ module_group_summary_formula: `${prefix}{{value}}${suffix}` });
    };

    const addGroup = function () {
      groups.value.push({
        order_no: groups.value.length,
        ignored: false,
        modules: [],
      });

      onUpdate({ module_groups: groups.value });
    };

    const onGroupUpdate = function (groupIdx, m) {
      groups.value.splice(groupIdx, 1, m);

      onUpdate({ module_groups: groups.value });
    };

    const onSummaryGroupUpdate = function (groupIdx, m) {
      let total = 0;
      let groupModules = groups.value[groupIdx].modules;
      groupModules.forEach((g) => {
        if (!g.ignored) {
          total = floatingPointFix(total + parseFloat(g.sub_total) || 0);
        }
      });

      if (m.group_formula) {
        try {
          if (m.group_formula.includes("{{value}}")) {
            const formula = m.group_formula.replaceAll("{{value}}", total);
            total = floatingPointFix(eval(formula));
          } else {
            const formula = total + m.group_formula;
            total = floatingPointFix(eval(formula));
          }
        } catch (e) {
          console.log(e);
        }
      }

      groups.value[groupIdx] = {
        ...groups.value[groupIdx],
        ...m,
        calculated_sub_total: total,
      };

      onUpdate({ module_groups: groups.value });
    };

    const removeGroup = function (groupIdx) {
      groups.value.splice(groupIdx, 1);

      onUpdate({ module_groups: groups.value });
    };

    const fixNumber = (num) => Number(num.toPrecision(15));

    const beforeAdjustments = function (i) {
      const item = i || props.rbuItem;
      const moduleGroups = item.module_groups || [];

      let total = 0;

      moduleGroups.forEach((g) => {
        if (!g.ignored) {
          total = floatingPointFix(
            total + parseFloat(g.calculated_sub_total) || 0
          );
        }
      });

      const active_group = moduleGroups.filter((g) => !g.ignored);

      if (
        item.module_group_value_mode === RBU_MODULE_GROUP_VALUE_MODE.AVERAGE &&
        active_group.length > 0
      ) {
        total = floatingPointFix(total / active_group.length);
      }

      return total;
    };

    const afterAdjustments = function (i) {
      const item = i || props.rbuItem;
      let sub_total = beforeAdjustments(item);
      if (item.module_group_summary_formula) {
        let value = sub_total;
        try {
          let formula = item.module_group_summary_formula.replace(
            "{{value}}",
            value
          );
          value = floatingPointFix(eval(formula));
          value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;
        } catch (e) {
          console.debug(e);
        }
        sub_total = value;
      }

      function applyValueAdjustment() {
        if (item.adjustment_value && parseFloat(item.adjustment_value)) {
          sub_total = floatingPointFix(
            sub_total + parseFloat(item.adjustment_value)
          );
        }
      }

      function applyPercentageAdjustment() {
        if (
          item.adjustment_percentage &&
          parseFloat(item.adjustment_percentage)
        ) {
          sub_total = floatingPointFix(
            (sub_total * parseFloat(item.adjustment_percentage)) / 100
          );
        }
      }

      if (item.adjustment_value_first) {
        applyValueAdjustment();
        applyPercentageAdjustment();
      } else {
        applyPercentageAdjustment();
        applyValueAdjustment();
      }

      return Math.round(floatingPointFix(sub_total * 100)) / 100;
    };

    const onAdjustmentValueFormulaUpdate = function (evt) {
      console.debug("onAdjustmentValueFormulaUpdate", evt);

      let value;

      if (evt) {
        try {
          value = floatingPointFix(eval(evt));
        } catch (e) {
          value = 0;
          console.debug(e);
        }
      } else {
        value = 0;
      }

      value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;

      onUpdate({
        adjustment_value: value,
        adjustment_value_formula: evt,
      });
    };

    const onAdjustmentPercentageFormulaUpdate = function (evt) {
      console.debug("onAdjustmentPercentageFormulaUpdate", evt);

      let value;

      if (evt) {
        try {
          value = floatingPointFix(eval(evt));
        } catch (e) {
          value = 0;
          console.debug(e);
        }
      } else {
        value = 100;
      }

      value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;

      onUpdate({
        adjustment_percentage: value,
        adjustment_percentage_formula: evt,
      });
    };

    const onUpdate = function (evt) {
      console.debug("Rbu Item Update: ", evt);

      let updates = {
        ...props.rbuItem,
        ...evt,
      };

      updates.beforeAdjustments = beforeAdjustments(updates);
      updates.calculated_rate = afterAdjustments(updates);

      emit("update", updates);
    };

    const compAfterSummaryGroupTotalFormula = computed(() => {
      if (props.rbuItem.module_group_summary_formula) {
        let value = compBeforeAdjustments.value;
        try {
          let formula = props.rbuItem.module_group_summary_formula.replace(
            "{{value}}",
            value
          );
          value = floatingPointFix(eval(formula));
          value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;
        } catch (e) {
          console.debug(e);
        }
        return value;
      } else {
        return compBeforeAdjustments.value;
      }
    });

    watch(
      () => props.rbuItem,
      (newValue) => {
        groups.value = [];
        groups.value = newValue.module_groups || [];

        if (groups.value.length === 0) {
          addGroup();
        }
      },
      { immediate: true }
    );

    return {
      moduleGroupValueModeOptions,
      compBeforeAdjustments,
      groups,
      addGroup,
      onGroupUpdate,
      onSummaryGroupUpdate,
      removeGroup,
      onUpdate,
      onAdjustmentValueFormulaUpdate,
      onAdjustmentPercentageFormulaUpdate,

      summaryGroupTotalFormulaPrefix,
      summaryGroupTotalFormulaSuffix,
      onSummaryGroupTotalFormulaUpdate,
      compAfterSummaryGroupTotalFormula,
    };
  },
};
</script>

<style lang="scss">
.no-border-table td {
  border-bottom: none !important;
}

.bordered-row td {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-bottom: none !important;
}

.nsr-item-summary {
  padding: 1rem;
  background: rgba(0, 0, 0, 0.03);

  .nsr-item-summary-header {
    font-weight: bold;
  }

  thead {
    background: rgba(0, 0, 0, 0.1);
  }

  .nsr-extra-item-column-1 {
    width: 10%;
  }

  .nsr-extra-item-column-2 {
    width: 15%;
  }

  .nsr-extra-item-column-price {
    width: 10%;
  }

  .nsr-extra-item-column-multiplier {
    width: 10%;
  }

  .nsr-extra-item-column-formula {
    width: 20%;
  }

  .nsr-extra-item-column-description {
    width: 25%;
  }

  .nsr-extra-item-column-action {
    width: 10%;
  }
}
</style>
